import React from "react";
import { Nav } from "react-bootstrap";

const tabs = [
    { id: 'general_details', label: 'GENERAL DETAILS' },
    { id: 'professional_details', label: 'PROFESSIONAL DETAILS' },
    { id: 'availability', label: 'AVAILABILITY' },
    { id: 'sign_in_and_security', label: 'SIGN IN & SECURITY' },
    { id: 'notifications', label: 'NOTIFICATIONS' }
  ];


const ProfileNavBar = ({ activeTab, setActiveTab}) => {

  return (
    <Nav
      activeKey={activeTab}
      onSelect={(k) => setActiveTab(k)}
      className="profile-nav-container status-tabs"
      
    >
      {tabs.map((tab) => (
        <Nav.Item key={tab.id}>
          <Nav.Link eventKey={tab.id}>
            {tab.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default ProfileNavBar;